import { ShieldCheck } from "lucide-react";
import { scrollToJoin } from "@/App";

export const Footer = () => (
  <footer data-testid="footer" className="bg-night text-white py-20 sm:py-24">
    <div className="max-w-6xl mx-auto px-6">
      <p
        data-testid="footer-wordmark"
        aria-hidden="true"
        className="font-display font-bold uppercase text-center leading-none tracking-tight outline-word-light text-[clamp(3.5rem,15vw,13rem)] select-none"
      >
        ProofBuy
      </p>
      <div className="mt-14 flex flex-col sm:flex-row sm:items-start justify-between gap-10">
        <div className="max-w-xl">
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-lg bg-trust flex items-center justify-center">
              <ShieldCheck size={18} className="text-white" />
            </span>
            <span className="font-display font-bold text-2xl tracking-tight">ProofBuy</span>
          </div>
          <p className="mt-5 text-sm sm:text-base text-gray-400 leading-relaxed">
            A community record of what digital products and courses actually deliver — built on verified buyer
            receipts, not accusations. We publish factual purchase experiences so people can spend their money
            meaningfully.
          </p>
        </div>
        <button
          data-testid="footer-early-access-button"
          onClick={scrollToJoin}
          className="shrink-0 rounded-full bg-trust text-white text-sm font-semibold px-6 py-3 transition-colors duration-200 hover:bg-trust-dark"
        >
          Get early access
        </button>
      </div>
      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-gray-500">
        <span>© 2026 ProofBuy. Facts, not name-calling.</span>
        <span className="flex items-center gap-4">
          <span>Every verified review: payment screenshot + product screenshot.</span>
          <a data-testid="footer-privacy-link" href="/privacy" className="underline underline-offset-2 hover:text-gray-300 transition-colors duration-200">Privacy Policy</a>
          <a data-testid="footer-terms-link" href="/terms" className="underline underline-offset-2 hover:text-gray-300 transition-colors duration-200">Terms of Use</a>
          <a data-testid="footer-admin-link" href="/admin" className="underline underline-offset-2 hover:text-gray-300 transition-colors duration-200">Admin</a>
        </span>
      </div>
    </div>
  </footer>
);
